import React from 'react'
import {RadioGroup} from 'rsuite'
import Radio from 'rsuite/Radio'
import styled, {keyframes} from 'styled-components';
import {fadeInDown} from 'react-animations';
import classes from './EmployeeStep.module.css'
import {NavText} from '../../../components/NavElements';
import {Logo} from '../../../components/Logo/Logo';
import {Button} from '../../../components/Button/Button';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TextField from '../../../components/TextField/TextField';
import {default as TFC} from '@mui/material/TextField';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import B from '../../../assets/B.png'
import {Formik} from 'formik';
import * as Yup from 'yup';
import {IUserData, setUserData, unsetUserData} from "../../../State/Register/UserDataSlice";
import {useDispatch, useSelector} from "react-redux";
import {IRootState} from "../../../State/Store";
import {useHistory} from "react-router-dom";
import {serverConn} from '../../../API/apiRequest';
import {login} from "../../../State/Slice/userSlice";
import {toast, ToastContainer} from "material-react-toastify";

const welcomeAnimation = keyframes`${fadeInDown}`
const WelcomeDiv = styled.div`
  animation: 0.6s ${welcomeAnimation};
`;

interface Props {
}

export const EmployeeStep: React.FC<Props> = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const UserData: IUserData | null = useSelector((s: IRootState) => s.UserData);
    return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ToastContainer
                        closeOnClick={false}
                        autoClose={1500}
                        pauseOnHover
                        newestOnTop
                        hideProgressBar={false}

                        position="bottom-right" rtl/>
                <div className={classes.containerk}>
                    <div className={classes.logoContainer}>
                        <NavText to='/'><Logo/></NavText>
                    </div>

                    <Formik initialValues={{
                        Sadat: UserData && UserData.Sadat ? UserData.Sadat : "",
                        address: UserData && UserData.address ? UserData.address : "",
                        birthday: UserData && UserData.birthday ? UserData.birthday : "",
                        gender: UserData && UserData.gender ? UserData.gender : "",
                    }} validationSchema={Yup.object().shape(
                            {
                                Sadat: Yup.string().required('error'),
                                address: Yup.string().required('برجاء ادخال عنوانك'),
                                birthday: Yup.string().required('برجاء ادخل تاريخ الميلاد'),
                                gender: Yup.string().required('error'),
                            })}
                            onSubmit={async(Values: any) => {
                                await dispatch(setUserData(Values))
                                if(UserData) {
                                    let data = {
                                        name: UserData.name,
                                        email: UserData.email,
                                        phone: UserData.phone,
                                        password: UserData.p_s,
                                        isSadat: Values.Sadat === "Yes" ? true : false,
                                        addressInfo: Values.address,
                                        birthdate: Values.birthday,
                                        gender: Values.gender === "male" ? "ذكر" : "انثي"
                                    };
                                    serverConn.post(`/signup/ee`, data).then(async(res) => {
                                        if(res.status === 200 || res.status === 201) {
                                            await localStorage.setItem('user', JSON.stringify(res.data))
                                            await dispatch(login({
                                                type: res.data.type,
                                                name: res.data.name,
                                                picture: res.data.picture,
                                                refresh: res.data.refreshToken,
                                                logId: res.data.log
                                            }))
                                            await dispatch(unsetUserData())
                                            //   window.location.replace('/employee/home');
                                        }
                                    }).catch(err => {
                                        toast.error(err.response.data.errors[0]);
                                        setTimeout(async() => {
                                            if(err.response.data.errors[0] === "الإسم غير صحيح من فضلك قم بكتابة الإسم كامل") {
                                                await dispatch(setUserData({name: undefined}))
                                                history.push('/register/employee')
                                            } else if(err.response.data.errors[0] === "البريد الإلكتروني غير صحيح") {
                                                await dispatch(setUserData({email: undefined}))
                                                history.push('/register/employee')
                                            } else if(err.response.data.errors[0] === "المستخدم مسجل بالفعل") {
                                                await dispatch(unsetUserData())
                                                history.push('/login')
                                            }
                                        }, 1000)
                                    })
                                }
                                // history.push('/employee/step')
                            }}
                    >
                        {({
                              setFieldValue,
                              handleSubmit,
                              values,
                              errors,
                              touched
                          }) => (
                                <>
                                    <div className={classes.all}>
                                        <div className={classes.left}>

                                            <div className={classes.moreInfo}>


                                                <div>

                                                    <p className={classes.label}
                                                       style={errors.Sadat && touched.Sadat ? {color: "tomato"} : {color: "#fff"}}>هل
                                                        تقيم في مدينة السادات؟</p>
                                                    <RadioGroup
                                                            style={{
                                                                display: 'flex',
                                                                width: 250,
                                                                justifyContent: 'space-around',
                                                                color: 'white'
                                                            }}
                                                            name="Sadat"

                                                            inline={true}
                                                            onChange={(t) => {
                                                                setFieldValue("Sadat", t)
                                                            }}
                                                            value={values.Sadat}
                                                    >
                                                        <Radio value="No">لا</Radio>
                                                        <Radio value="Yes">نعم</Radio>
                                                    </RadioGroup>

                                                </div>
                                                <div>
                                                    <p className={classes.label}
                                                       style={errors.address && touched.address ? {color: "tomato"} : {color: "#fff"}}>العنوان</p>
                                                    <TextField
                                                            containerStyle={{margin: 5}}
                                                            bgColor='#1D252D'
                                                            iconName={'FiMapPin'}
                                                            placeholder='العنوان'
                                                            width={200}
                                                            value={values.address}
                                                            handleChange={(e) => {
                                                                setFieldValue("address", e.target.value)
                                                            }}
                                                    />
                                                </div>
                                                <div>
                                                    <p className={classes.label}
                                                       style={errors.birthday && touched.birthday ? {color: "tomato"} : {color: "#fff"}}>تاريخ
                                                        الميلاد</p>
                                                    <MobileDatePicker
                                                            value={values.birthday !== "" ? values.birthday : null}

                                                            inputFormat='yyyy/MM/dd'
                                                            disableFuture
                                                            openTo="year"
                                                            views={['year', 'month', 'day']}
                                                            onChange={(newValue) => {
                                                                setFieldValue("birthday", newValue ? new Date(newValue).toString() : null)
                                                            }}
                                                            renderInput={(params) => <TFC
                                                                    style={{
                                                                        backgroundColor: '#1D252D',
                                                                        borderRadius: 8,
                                                                        width: 255,
                                                                        height: 50
                                                                    }}
                                                                    sx={{
                                                                        input: {color: '#fff'},
                                                                        div: {
                                                                            height: 50,
                                                                            '&:focus': {border: '1px solid #BBBBBB'}
                                                                        }
                                                                    }}
                                                                    variant='outlined'
                                                                    placeholder='1999/01-01'
                                                                    {...params}
                                                            />
                                                            }
                                                    />
                                                </div>
                                                <div>
                                                    <p className={classes.label}
                                                       style={errors.gender && touched.gender ? {color: "tomato"} : {color: "#fff"}}>النوع</p>
                                                    <RadioGroup
                                                            style={{
                                                                display: 'flex',
                                                                width: 250,
                                                                justifyContent: 'space-around',
                                                                color: 'white'
                                                            }}
                                                            name="radioLista"
                                                            inline={true}
                                                            onChange={(t) => {
                                                                setFieldValue("gender", t);
                                                            }}
                                                            value={values.gender}
                                                    >
                                                        <Radio value="female">انثي</Radio>
                                                        <Radio value="male">ذكر</Radio>
                                                    </RadioGroup>
                                                </div>


                                            </div>

                                        </div>
                                        <div className={classes.right}>
                                            <div>
                                                <WelcomeDiv className={classes.welcome}>
                                                    <p>مرحباً بك</p>
                                                </WelcomeDiv>
                                                <p className={classes.tip}>يرجي استكمال بعض البيانات</p>
                                            </div>
                                            <img alt='B' src={B} className={classes.img}/>
                                        </div>
                                    </div>
                                    <div className={"w-100 d-flex justify-content-center"}>
                                        <Button
                                                color='#5A8D59'

                                                onPress={() => handleSubmit()}>التالي</Button>
                                    </div>

                                </>
                        )}
                    </Formik>
                </div>
            </LocalizationProvider>
    )
}
